import { useMemo } from 'react';
import { createSessionStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/session-storage/index.tsx';
import { SHOULD_SHOW_SCRUM_ONBOARDING_MODAL } from '@atlassian/jira-onboarding-core/src/constants.tsx';
import { useShouldShowScrumOnboardingExperience } from '@atlassian/jira-onboarding-quickstart-core/src/services/index.tsx';

const sessionStorageProvider = createSessionStorageProvider('onboarding-core');

export const useShouldShowScrumOnboardingModal = () => {
	const [shouldShowScrumOnBoardingExperience] = useShouldShowScrumOnboardingExperience();

	const sessionStorageVal = useMemo(
		() => sessionStorageProvider.get(SHOULD_SHOW_SCRUM_ONBOARDING_MODAL),
		[],
	);

	return shouldShowScrumOnBoardingExperience !== false && sessionStorageVal !== undefined;
};
